import React from 'react';
import { motion } from 'framer-motion';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://static.prod-images.emergentagent.com/jobs/a47baca2-6813-4a68-b147-4e346342c0a9/images/23fc2fc3f750b92679b28c4b11b4b35409e0c87aa063045fa86ff4ebe792715f.png)'
        }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-8"
        >
          <div className="flex flex-col items-center justify-center mb-8">
            <div className="text-xs md:text-sm font-bold uppercase tracking-[0.3em] text-[#C9A84C]">
              Matt Pugh · Professional Basketball Trainer
            </div>
          </div>

          <h1
            className="text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter text-white text-shadow-strong leading-tight"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
            data-testid="hero-title"
          >
            Elite Training<br />For Elite Athletes
          </h1>

          <p
            className="text-lg md:text-xl text-[#94A3B8] max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="hero-subtitle"
          >
            Professional basketball skills training with Matt Pugh.<br />
            Developing champions from high school to the NBA.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <button
              onClick={() => scrollToSection('elite-program')}
              className="bg-[#C9A84C] text-[#061324] px-8 py-4 rounded-sm font-bold uppercase tracking-wide text-sm hover:bg-[#d8b655] transition-all gold-glow"
              data-testid="hero-cta-elite"
            >
              Elite Program
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="bg-[#C9A84C] text-[#061324] px-8 py-4 rounded-sm font-bold uppercase tracking-wide text-sm hover:bg-[#d8b655] transition-all gold-glow"
              data-testid="hero-cta-services"
            >
              View Services
            </button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="mt-20 flex justify-center"
        >
          <div className="glass-effect border border-white/10 rounded-sm py-6 px-8 inline-flex items-center gap-8 text-center">
            <div>
              <div className="text-3xl font-black text-[#C9A84C]" style={{ fontFamily: 'Montserrat, sans-serif' }}>15+</div>
              <div className="text-sm uppercase tracking-wide text-[#94A3B8]">Years Experience</div>
            </div>
            <div className="h-12 w-px bg-white/20" />
            <div>
              <div className="text-3xl font-black text-[#C9A84C]" style={{ fontFamily: 'Montserrat, sans-serif' }}>500+</div>
              <div className="text-sm uppercase tracking-wide text-[#94A3B8]">Players Trained</div>
            </div>
            <div className="h-12 w-px bg-white/20" />
            <div>
              <div className="text-3xl font-black text-[#C9A84C]" style={{ fontFamily: 'Montserrat, sans-serif' }}>NBA</div>
              <div className="text-sm uppercase tracking-wide text-[#94A3B8]">Level Coaching</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};